import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    OnInit
} from '@angular/core';
import {
    MatDialogRef,
    MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { take } from 'rxjs/operators';
import { LoggingService } from '../../services/logging/logging.service';
import { ResponseStatus } from '../../../common';

export interface ConfirmData {
    showOk: boolean;
    showCancel: boolean;
    okText: string;
    cancelText: string;
    dialogText: string;
    headerText: string;
    okClass: string;
    cancelClass: string;
    baseZIndex: number;
    maxStatus: ResponseStatus;
    dialogStyle?: string;
}

@Component({
    selector: 'ef-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent implements OnInit, AfterViewInit {
    constructor(
        public dialogRef: MatDialogRef<ConfirmComponent>,
        protected log: LoggingService,
        private elementRef: ElementRef<HTMLElement>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmData
    ) {
        const options = data || {};
        this.data = {
            ...{
                showOk: true,
                showCancel: true,
                okText: 'OK',
                cancelText: 'Cancel',
                dialogText: 'Are you sure?',
                headerText: 'Confirmation',
                okClass: 'p-button-success p-button-text',
                cancelClass: 'p-button-danger p-button-text',
                maxStatus: ResponseStatus.None,
                baseZIndex: 99999999
            },
            ...options
        };
        this.log.verbose({ type: 'ConfirmComponent', data: this.data });
    }

    ngOnInit() {}

    ngAfterViewInit(): void {
        this.dialogRef
            .afterOpened()
            .pipe(take(1))
            .subscribe(() => this.deferFocusToDialog());
    }

    onDialogShow(): void {
        this.deferFocusToDialog();
    }

    private deferFocusToDialog(): void {
        // Run after the click that opened the dialog so focus is not returned to the trigger.
        setTimeout(() => this.focusInitialControl(), 0);
    }

    private focusInitialControl(): void {
        const root = this.elementRef.nativeElement;
        const target =
            root.querySelector<HTMLElement>('[cdkFocusInitial]') ??
            root.querySelector<HTMLElement>('button[mat-dialog-close]');
        target?.focus();
    }
}
